import * as React from 'react';
export const chevronRightSvg = React.forwardRef(function chevronRightSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M4.381.381a.875.875 0 0 0 0 1.238L10.763 8 4.38 14.381a.875.875 0 1 0 1.24 1.239l7-7a.875.875 0 0 0 0-1.238l-7-7a.875.875 0 0 0-1.238 0Z',
    }),
  );
});
chevronRightSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var chevronRight = {
  category: 'icon',
  colorable: true,
  name: 'chevronRight',
  svg: chevronRightSvg,
};
